// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:06:30

export default {
  "id": "number-domination",
  "slug": "number-domination",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0a8abcb4fd9442e99827c02a72dd9f12-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0a8abcb4fd9442e99827c02a72dd9f12/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Number Domination",
      "description": "Number Domination is a turn-based strategy card game where players compete to claim tiles on the board using number cards (0-9). Create chains of three or more, match pairs, or make a \"Perfect 9\" by summing two cards to 9. Each successful move earns points and claims tiles. At the end, each occupied tile grants an extra point to its owner. Play in Face the Challenger or Face the Champion mode and win with smart moves. Think ahead, outplay your opponent, and dominate the numbers!",
      "instructions": "Use a mouse or touchpad to place number cards by tapping or dragging. Form pairs or chains to earn points and claim tiles. The player with the most points wins!",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2players",
        "board",
        "math",
        "number",
        "thinking"
      ]
    },
    "zh-CN": {
      "title": "数字霸权",
      "description": "数字霸权是一款回合制策略卡牌游戏，玩家通过使用数字卡（0-9）在棋盘上争夺地砖。创建三个或更多的一串，匹配一对，或者通过两张卡牌相加得到9来制作“完美9”。每一次成功的移动都能获得分数并占据地砖。最后，每个被占领的地砖都会为它的拥有者额外增加一分。在挑战者面对或冠军面对模式下进行游戏，用聪明的策略赢得比赛。深思熟虑，超越对手，统治数字！",
      "instructions": "使用鼠标或触摸板，通过点击或拖动放置数字牌。组成对或链以获得分数并占领瓷砖。得分最高的玩家获胜！",
      "genres": [
        "谜题"
      ],
      "tags": [
        "2人游戏",
        "棋盘",
        "数学",
        "数字",
        "思考"
      ]
    },
    "zh-TW": {
      "title": "數字霸權",
      "description": "數字霸權是一款回合制策略卡牌遊戲，玩家們競相在棋盤上使用數字卡（0-9）佔領地圖。建立三個或以上的連鎖，配對卡片，或透過兩張卡片之和為9來完成“完美9”。每次成功的移動都能獲得分數並佔領地圖。遊戲結束時，每個被佔領的地圖為其所有者額外加一分。在挑戰者對決或挑戰冠軍模式中遊玩，並以智慧之舉獲勝。預先思考，超越對手，霸佔數字！",
      "instructions": "使用滑鼠或觸控板，透過點擊或拖曳來放置數字卡。形成配對或連鎖以獲得分數並領取瓦片。得分最高的玩家獲勝！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "兩玩家",
        "棋盤",
        "數學",
        "數字",
        "思考"
      ]
    },
    "zh-HK": {
      "title": "數字統治",
      "description": "數字統治是一款回合制策略卡牌遊戲，玩家們透過使用數字卡（0-9）在棋盤上爭奪地圖上的Tile。建立三個或以上的連鎖，匹配對子，或透過將兩張卡片的數字相加獲得「完美9」。每個成功的移動都能獲得分數並宣佈Tile的所有權。遊戲結束時，每個被佔據的Tile都會為其所有者帶來額外的分數。在「挑戰對手」或「對決冠軍」模式下進行遊戲，並透過精明的移動獲勝。預先思考，超越對手，統治數字！",
      "instructions": "使用滑鼠或觸控板，透過輕觸或拖曳放置數字牌。組成對或連鎖來獲得分數並宣佈獲勝！積分最高的玩家獲勝！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "兩玩家",
        "棋盤",
        "數學",
        "數字",
        "思考"
      ]
    },
    "ja": {
      "title": "数の支配",
      "description": "Number Dominationは、プレイヤーがボード上のタイルを数カード（0-9）を使って獲得することを目指すターン制ストラテジーカードゲームです。三つ以上の連鎖を作成し、ペアをマッチングするか、2枚のカードの合計が9になる「パーフェクト9」を作成します。各成功の動作でポイントが獲得され、タイルが獲得されます。最後に、それぞれの占領されたタイルは、所有者に追加のポイントを提供します。Face the ChallengerまたはFace the Championモードでプレイし、賢い動作で勝利しましょう。先手を打ち、敵対者を圧倒し、数を支配しましょう！",
      "instructions": "マウスやタッチパッドを使って、タップまたはドラッグして数字カードを配置します。ポイントを獲得し、タイルを獲得するためにペアやチェーンを作成します。ポイントが最も多いプレイヤーが勝ちます！",
      "genres": [
        "パズル"
      ],
      "tags": [
        "2プレイヤー",
        "ボード",
        "数学",
        "数字",
        "思考"
      ]
    },
    "ko": {
      "title": "숫자 통치",
      "description": "Number Domination은 플레이어들이 0-9의 숫자 카드를 사용하여 보드에 타일을 획득하는 턴제 전략 카드 게임입니다. 세 개 이상의 연속, 짝 맞추기, 또는 두 카드의 합이 9인 \"최고의 9\"을 만들어주세요. 각 성공적인 이동은 포인트를 얻고 타일을 획득합니다. 최종적으로, 각 점유된 타일은 주인에게 추가 포인트를 주습니다. Face the Challenger 또는 Face the Champion 모드에서 플레이하고 지능적인 이동으로 승리하세요. 사전에 생각하고, 상대를 밀어내고 숫자를支配하세요!",
      "instructions": "마우스나 터치패드를 사용하여 클릭이나 드래그로 숫자 카드를 배치하세요. 점수를 획득하고 타일을 요청하여 쌓아보세요. 가장 많은 점수를 얻은 플레이어가 승리합니다!",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "2players",
        "보드",
        "수학",
        "숫자",
        "사고력"
      ]
    },
    "fr": {
      "title": "Numéro de Domination",
      "description": "Number Domination est un jeu de stratégie de cartes par tours où les joueurs se disputent pour revendiquer des tuiles sur le plateau en utilisant des cartes numériques (0-9). Créez des chaînes de trois ou plus, faites des paires, ou formez un \"9 parfait\" en additionnant deux cartes pour obtenir 9. Chaque coup réussi rapporte des points et revendique des tuiles. À la fin, chaque tuile occupée rapporte un point supplémentaire à son propriétaire. Jouez en mode Face the Challenger ou Face the Champion et gagnez avec des coups stratégiques. Anticipez, outjouez votre adversaire, et dominez les nombres !",
      "instructions": "Utilisez une souris ou un pavé tactile pour placer des cartes à numéros en tapant ou en glissant. Formez des paires ou des chaînes pour gagner des points et revendiquer des tuiles. Le joueur avec le plus de points gagne !",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2 joueurs",
        "plateau",
        "mathématiques",
        "nombre",
        "réflexion"
      ]
    }
  }
};
